module.exports = __webpack_public_path__ + "img/pmg-active.ef42c64a.png";